export default __webpack_public_path__ + "static/media/dollars.7bfc5f2c.png";